(function () {
  const STORAGE_POPUP_UNTIL = 'zenith_popup_until';
  const STORAGE_EMAIL = 'zenith_email_subscribed';
  const DAY_MS = 24 * 60 * 60 * 1000;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function copyText(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text);
    }
    const ta = document.createElement('textarea');
    ta.value = text;
    document.body.appendChild(ta);
    ta.select();
    document.execCommand('copy');
    document.body.removeChild(ta);
    return Promise.resolve();
  }

  function isPopupCooldownActive() {
    try {
      const until = parseInt(localStorage.getItem(STORAGE_POPUP_UNTIL) || '0', 10);
      if (until && Date.now() < until) return true;
      if (localStorage.getItem(STORAGE_EMAIL)) return true;
    } catch (e) {}
    return false;
  }

  function setPopupCooldown(days) {
    try {
      const d = parseInt(days || '7', 10);
      localStorage.setItem(STORAGE_POPUP_UNTIL, String(Date.now() + d * DAY_MS));
    } catch (e) {}
  }

  function initReveal() {
    const els = document.querySelectorAll('[data-zp-reveal]');
    if (!els.length || !('IntersectionObserver' in window)) {
      els.forEach((el) => el.classList.add('is-visible'));
      return;
    }
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );
    els.forEach((el) => io.observe(el));
  }

  function initPopup() {
    const popup = document.getElementById('zenith-email-popup');
    if (!popup) return;

    const closeBtns = popup.querySelectorAll('[data-zp-close]');
    const formEl = popup.querySelector('#zenith-popup-form');
    const formWrap = popup.querySelector('[data-zp-form-wrap]');
    const successBox = popup.querySelector('[data-zp-success]');
    const cooldownDays = popup.dataset.cooldownDays || '7';

    function openPopup() {
      popup.classList.add('is-open');
      popup.setAttribute('aria-hidden', 'false');
      document.body.classList.add('zp-modal-open');
    }

    function closePopup() {
      popup.classList.remove('is-open');
      popup.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('zp-modal-open');
      setPopupCooldown(cooldownDays);
    }

    function showCodeSuccess() {
      if (formWrap) formWrap.style.display = 'none';
      if (successBox) successBox.classList.add('is-visible');
      openPopup();
      try {
        localStorage.setItem(STORAGE_EMAIL, '1');
        setPopupCooldown(cooldownDays);
      } catch (e) {}
    }

    closeBtns.forEach((btn) => btn.addEventListener('click', closePopup));
    popup.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closePopup();
    });
    popup.addEventListener('click', (e) => {
      if (e.target === popup.querySelector('.zenith-popup__backdrop')) closePopup();
    });

    document.querySelectorAll('[data-zp-open-popup]').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        openPopup();
      });
    });

    document.querySelectorAll('[data-zp-copy]').forEach((copyBtn) => {
      copyBtn.addEventListener('click', () => {
        const codeEl =
          copyBtn.closest('[data-zp-success]')?.querySelector('[data-zp-code]') ||
          copyBtn.parentElement?.querySelector('[data-zp-code]');
        const code = codeEl ? codeEl.textContent.trim() : 'ZENITH23';
        copyText(code).then(() => {
          copyBtn.textContent = 'Copied!';
          setTimeout(() => {
            copyBtn.textContent = copyBtn.dataset.defaultLabel || 'Copy code';
          }, 2000);
        });
      });
    });

    if (
      window.location.search.indexOf('customer_posted') !== -1 ||
      window.location.search.indexOf('form_type=customer') !== -1
    ) {
      showCodeSuccess();
      return;
    }

    if (isPopupCooldownActive()) return;

    const delay = parseInt(popup.dataset.delay || '3000', 10);
    setTimeout(openPopup, delay);
  }

  function initCarousels() {
    document.querySelectorAll('[data-zp-carousel]').forEach((track) => {
      let isDown = false;
      let startX;
      let scrollLeft;

      track.addEventListener('mousedown', (e) => {
        isDown = true;
        track.classList.add('is-dragging');
        startX = e.pageX - track.offsetLeft;
        scrollLeft = track.scrollLeft;
      });
      track.addEventListener('mouseleave', () => {
        isDown = false;
        track.classList.remove('is-dragging');
      });
      track.addEventListener('mouseup', () => {
        isDown = false;
        track.classList.remove('is-dragging');
      });
      track.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - track.offsetLeft;
        track.scrollLeft = scrollLeft - (x - startX) * 1.2;
      });
    });
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  const STORAGE_BUNDLE_DISCOUNT = 'zenith_pending_bundle_discount';

  async function applyDiscountCode(code) {
    if (!code) return false;
    try {
      await fetch('/discount/' + encodeURIComponent(code), {
        method: 'GET',
        credentials: 'same-origin',
        redirect: 'follow',
      });
      const cart = await fetch('/cart.js', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      }).then((r) => r.json());
      const discounted =
        (cart.total_discount && cart.total_discount > 0) ||
        (cart.cart_level_discount_applications && cart.cart_level_discount_applications.length > 0);
      return discounted;
    } catch (e) {
      return false;
    }
  }

  function updateSlotPreview(slot) {
    const row = slot.closest('.zenith-bundle-slot');
    if (!row) return;
    const img = row.querySelector('[data-zp-bundle-preview-img]');
    const ph = row.querySelector('[data-zp-bundle-preview-ph]');
    const opt = slot.options[slot.selectedIndex];
    if (!opt || !opt.value) {
      if (img) {
        img.src = '';
        img.alt = '';
        img.classList.add('is-hidden');
      }
      if (ph) ph.classList.remove('is-hidden');
      return;
    }
    const src = opt.dataset.image || '';
    const title = opt.dataset.title || opt.textContent.trim();
    if (img && src) {
      img.src = src;
      img.alt = title;
      img.classList.remove('is-hidden');
      if (ph) ph.classList.add('is-hidden');
    } else if (ph) {
      if (img) img.classList.add('is-hidden');
      ph.classList.remove('is-hidden');
      ph.textContent = title.split('(')[0].trim().slice(0, 18);
    }
  }

  function initCartBundleDiscount() {
    let code = '';
    try {
      code = sessionStorage.getItem(STORAGE_BUNDLE_DISCOUNT) || '';
    } catch (e) {}
    if (!code) return;
    applyDiscountCode(code).then((ok) => {
      try {
        sessionStorage.removeItem(STORAGE_BUNDLE_DISCOUNT);
      } catch (e) {}
      if (!ok && window.location.pathname.indexOf('/cart') !== -1) {
        window.location.href =
          '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent('/cart');
      }
    });
  }

  function initBundleBuilders() {
    document.querySelectorAll('[data-zp-bundle]').forEach((card) => {
      const slots = card.querySelectorAll('[data-zp-bundle-slot]');
      const summary = card.querySelector('[data-zp-bundle-summary]');
      const addBtn = card.querySelector('[data-zp-bundle-add]');
      const errorEl = card.querySelector('[data-zp-bundle-error]');
      if (!slots.length || !addBtn) return;

      const requiredQty = parseInt(card.dataset.bundleQty || '0', 10);
      const bundlePriceCents = parseInt(card.dataset.bundlePriceCents || '0', 10);
      const discountCode = card.dataset.discountCode || '';
      const bundleName = card.dataset.bundleName || 'Bundle';
      const addBtnDefaultHtml = addBtn.innerHTML;

      function getSelections() {
        const selections = [];
        slots.forEach((slot) => {
          const opt = slot.options[slot.selectedIndex];
          if (opt && opt.value) {
            selections.push({
              variantId: parseInt(opt.value, 10),
              price: parseInt(opt.dataset.price || '0', 10),
            });
          }
        });
        return selections;
      }

      function updateSummary() {
        const selections = getSelections();
        const filled = selections.length;
        if (!summary) return;

        if (filled < requiredQty) {
          summary.textContent =
            'Select ' + (requiredQty - filled) + ' more item' + (requiredQty - filled === 1 ? '' : 's') + ' to complete your bundle.';
          addBtn.disabled = true;
          return;
        }

        const subtotal = selections.reduce((sum, s) => sum + s.price, 0);
        const savings = Math.max(0, subtotal - bundlePriceCents);
        summary.innerHTML =
          'Regular: <s>' +
          formatMoney(subtotal) +
          '</s> → Bundle: <strong>' +
          formatMoney(bundlePriceCents) +
          '</strong>' +
          (savings > 0 ? ' · <span class="savings">Save ' + formatMoney(savings) + '</span>' : '');
        addBtn.disabled = false;
      }

      slots.forEach((slot) => {
        slot.addEventListener('change', () => {
          updateSlotPreview(slot);
          updateSummary();
        });
        updateSlotPreview(slot);
      });
      updateSummary();

      addBtn.addEventListener('click', async () => {
        const selections = getSelections();
        if (selections.length < requiredQty) return;

        addBtn.disabled = true;
        addBtn.textContent = 'Adding…';
        if (errorEl) {
          errorEl.classList.remove('is-visible');
          errorEl.textContent = '';
        }

        try {
          const items = selections.map((s) => ({
            id: s.variantId,
            quantity: 1,
            properties: {
              Bundle: bundleName,
              _bundle_id: card.dataset.bundleId || 'zenith-bundle',
              _bundle_discount: discountCode,
            },
          }));

          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items }),
          });

          if (!res.ok) {
            const err = await res.json().catch(() => ({}));
            throw new Error(err.description || err.message || 'Could not add bundle to cart');
          }

          await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              attributes: {
                'Zenith Bundle': bundleName,
                'Bundle discount code': discountCode,
              },
            }),
          });

          const cartData = await res.json();
          document.dispatchEvent(
            new CustomEvent('cart:update', {
              detail: { cart: cartData, source: 'zenith-bundle' },
            })
          );

          if (discountCode) {
            try {
              sessionStorage.setItem(STORAGE_BUNDLE_DISCOUNT, discountCode);
            } catch (e) {}
            const applied = await applyDiscountCode(discountCode);
            if (applied) {
              window.location.href = '/cart';
            } else {
              window.location.href =
                '/discount/' +
                encodeURIComponent(discountCode) +
                '?redirect=' +
                encodeURIComponent('/cart');
            }
          } else {
            window.location.href = '/cart';
          }
        } catch (err) {
          if (errorEl) {
            errorEl.textContent = err.message || 'Something went wrong. Please try again.';
            errorEl.classList.add('is-visible');
          }
          addBtn.disabled = false;
          addBtn.innerHTML = addBtnDefaultHtml;
        }
      });
    });
  }

  ready(() => {
    initReveal();
    initPopup();
    initCarousels();
    initBundleBuilders();
    initCartBundleDiscount();
  });
})();
